/**
 * Account Tab
 *
 * Profile (name, avatar, password, connected accounts, delete account)
 * + Appearance (theme toggle).
 *
 * Embeds ProfilePage without the standalone back-button header.
 */

import { Sun, Moon, Monitor } from 'lucide-react';
import { useSettings } from '../../../hooks/useSettings';
import { ProfilePage } from '../../../features/auth/ProfilePage';

export function AccountTab() {
  const { settings, updateTheme } = useSettings();

  return (
    <>
      {/* Profile — embedded, no back button */}
      <ProfilePage />

      {/* Appearance */}
      <div className="bg-surface-raised-light dark:bg-surface-raised-dark border border-border-subtle-light dark:border-border-subtle-dark rounded-lg p-6 space-y-4">
        <h2 className="text-lg font-semibold text-text-primary-light dark:text-text-primary-dark">
          Appearance
        </h2>
        <p className="text-sm text-text-secondary-light dark:text-text-secondary-dark">
          Choose your preferred color theme.
        </p>

        <div className="flex gap-3">
          {[
            { value: 'light' as const, icon: Sun, label: 'Light' },
            { value: 'dark' as const, icon: Moon, label: 'Dark' },
            { value: 'system' as const, icon: Monitor, label: 'System' },
          ].map(({ value, icon: Icon, label }) => (
            <button
              key={value}
              onClick={() => updateTheme(value)}
              className={`
                flex-1 px-4 py-3 border-2 rounded-lg transition-all flex flex-col items-center gap-2
                ${
                  settings.theme === value
                    ? 'border-primary-500 bg-primary-50 dark:bg-primary-900/20'
                    : 'border-border-subtle-light dark:border-border-subtle-dark hover:border-border-hover-light dark:hover:border-border-hover-dark'
                }
              `}
            >
              <Icon
                className={`w-5 h-5 ${
                  settings.theme === value
                    ? 'text-primary-600 dark:text-primary-400'
                    : 'text-text-secondary-light dark:text-text-secondary-dark'
                }`}
              />
              <span
                className={`text-sm font-medium ${
                  settings.theme === value
                    ? 'text-primary-900 dark:text-primary-100'
                    : 'text-text-primary-light dark:text-text-primary-dark'
                }`}
              >
                {label}
              </span>
            </button>
          ))}
        </div>
      </div>

    </>
  );
}
